import { NewWatcherQueryParams } from '../../../watchers/watchers.types';

const getExpressionWords = (expression: string): Array<string> =>
  expression.split(' ');

export const getQueryAndKeywordsWords = (
  queryParams: NewWatcherQueryParams,
): Array<Array<string>> => {
  const queryWordsArray = queryParams.q
    ? [getExpressionWords(queryParams.q)]
    : [];
  const keywordsArray = queryParams.selectedKeywords
    ? queryParams.selectedKeywords.reduce(
        (accumulator: Array<Array<string>>, keyword) => {
          accumulator.push(getExpressionWords(keyword));
          return accumulator;
        },
        [],
      )
    : [];

  return queryWordsArray.concat(keywordsArray);
};
